import config from '../../../config';
import {checkStatus, authFetch, parseHeadersAndJson, checkStatusExceptNotFound} from '../../utils/http';
import {status} from '../../utils/constant';

export default class LiveRelationshipService {
  searchSubcontractorsByQuery(organisationId, selectedStatus, userId, query = '', page = 0, pageSize = 10) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/subcontractors?status=${selectedStatus}&query=${encodeURIComponent(query)}&organisationId=${organisationId}&userId=${userId}&page=${page}&size=${pageSize}`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        relationships: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  searchClientsByQuery(organisationId, selectedStatus, userId, query = '', page = 0, pageSize = 10) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/clients?status=${selectedStatus}&query=${encodeURIComponent(query)}&organisationId=${organisationId}&userId=${userId}&page=${page}&size=${pageSize}`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        relationships: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  addSubcontractors(subcontractorsIdList, organisationId) {
    const data = {
      organisationIds: subcontractorsIdList,
      fromEnrollment: false
    };
    return authFetch(`${config.relationshipApi}/api/v1/relationships/subcontractors/${organisationId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  addClients(clientsIdList, organisationId) {
    const data = {
      organisationIds: clientsIdList,
      fromEnrollment: false
    };
    return authFetch(`${config.relationshipApi}/api/v1/relationships/clients/${organisationId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  searchForSubcontractor(subcontractorId, clientId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/subcontractors/${clientId}?subcontractorId=${subcontractorId}`)
      .then(checkStatus)
      .then(response => (response.status === 204 ? null : response.json()));
  }

  searchForClient(clientId, subcontractorId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/clients/${subcontractorId}?clientId=${clientId}`)
      .then(checkStatusExceptNotFound);
  }

  getPendingSentInvitations(organisationId, page = 0, size = 10) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/subcontractors?clientId=${organisationId}&page=${page}&size=${size}&isEmitter=true&status=PENDING&status=REJECTED`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        relationships: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  accept(relationshipId) {
    const data = {
      status: status.ACCEPTED
    };
    return authFetch(`${config.relationshipApi}/api/v1/relationships/${relationshipId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => checkStatus(response, false))
      .then(response => response.json());
  }

  reject(relationshipId, rejectionReason) {
    const data = {
      status: status.REJECTED,
      rejectionReason
    };
    return authFetch(`${config.relationshipApi}/api/v1/relationships/${relationshipId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => checkStatus(response, false))
      .then(response => response.json());
  }

  resendInvitation(invitationId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/${invitationId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  getRelationship(relationshipId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/${relationshipId}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  deleteRelationship(relationshipId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/${relationshipId}`, {
      method: 'DELETE'
    })
      .then(checkStatus);
  }

  isFavoriteRelationship(clientId, subcontractorId, userId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/favorite?clientId=${clientId}&subcontractorId=${subcontractorId}&userId=${userId}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  switchFavoriteRelationshipState(clientId, subcontractorId, userId, isFavorite) {
    const data = {
      clientId,
      subcontractorId,
      userId,
      isFavorite
    };
    return authFetch(`${config.relationshipApi}/api/v1/relationships/favorite`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(checkStatus);
  }

  getSubcontractorsCountByUser(userId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/users/${userId}/subcontractors/count`)
      .then(checkStatus)
      .then(response => response.json());
  }

  searchSubcontractorsByUser(userId, query, page = 0, size = 10) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/users/${userId}/subcontractors?query=${encodeURIComponent(query)}&page=${page}&size=${size}`)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        subcontractors: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  getSubcontractorClientIds(userId, subcontractorId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/users/${userId}/subcontractors/${subcontractorId}`)
      .then(checkStatus)
      .then(response => response.json());
  }

  cancelPendingRelationship(relationshipId) {
    return authFetch(`${config.relationshipApi}/api/v1/relationships/pending/${relationshipId}`, {
      method: 'DELETE'
    })
      .then(checkStatus);
  }
}
